module.exports = __webpack_public_path__ + "static/img/chanping5.b0977bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp/chanping5.jpg
// module id = 9WUn
// module chunks = 0